Ext.define('SA.MaskView', {
    constructor({content}) {
        this.el = SA.Html.create({type: 'div', class: 'sa-mask-view', content});

        this.mask = Ext.widget({xtype: 'load-mask', renderTo: this.el, hidden: true, spinnerSize: 'medium'});
    },

    getEl() {
        return this.el;
    },

    hideMask() {
        this.mask.hide();
    },

    showMask() {
        this.mask.show();
    }
});